export default __webpack_public_path__ + "c8966a40e9182efb7f8286750907782e.jpg";